import { useMutationCallback } from 'shared/api/hooks';
import { useEffect } from 'react';
import { setEmailOk } from 'console/redux/main-actions';
import { useAction } from 'shared/hooks/redux/hooks';
export function useSetInitialEmail() {
    const [setInitialEmail, isLoading, response, error, is_send_request] = useMutationCallback('set_initial_email');
    const _setEmailOk = useAction(setEmailOk);
    useEffect(() => {
        if (response?.ok) {
            _setEmailOk(response.email);
        }
    }, [response]);
    return [setInitialEmail, isLoading, response, error, is_send_request];
}
